// USER-04 Roles: the open role lives in the address, `/admin/roles?role=<id>`, so a link (the Access log's
// "the role") opens that role directly and the address can be shared. Anything else is dropped: a URL
// is user input like any other.

export interface RolesSearch {
  readonly role?: string;
}

export function readRolesSearch(search: Record<string, unknown>): RolesSearch {
  return typeof search.role === 'string' && search.role !== '' ? { role: search.role } : {};
}

/** The address of one role on the Roles page. */
export function roleHref(roleId: string): string {
  return `/admin/roles?role=${encodeURIComponent(roleId)}`;
}
